export default `
mutation MarkAsNotProcessed(
  $responseKeys: [ResponseKey!]!, 
  $dailyActivityReportIds: [ID!]!, 
  $incidentReportIds: [ID!]!
) {
  markAsNotProcessed(
    responseKeys: $responseKeys, 
    dailyActivityReportIds: $dailyActivityReportIds, 
    incidentReportIds: $incidentReportIds
  ) {
    void
  }
}
`;
